import axios from 'axios';
import { axiosJwt } from '@/shared/auth/axiosJwt';

const apiBase = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_CHECKINS_GUICHE_PORT}${process.env.VUE_APP_API_PATH}/checkins/guiche`;

const wrapPublic = (promise) =>
    promise
        .then((response) => ({ success: true, data: response.data, status: response.status }))
        .catch((error) => {
            const status = error?.response?.status;
            const raw = error?.response?.data;
            let mensagem = 'Erro na requisição.';
            if (typeof raw === 'string' && raw.trim()) {
                mensagem = raw;
            } else if (raw?.message) {
                mensagem = raw.message;
            } else if (raw?.title) {
                mensagem = raw.title;
            } else if (error?.message) {
                mensagem = error.message;
            }
            return { success: false, errors: [mensagem], status };
        });

const escolherCliente = (autenticado) => (autenticado ? axiosJwt : null);

export const apiBaseUrl = apiBase;

const cliente = (autenticado) => (autenticado ? axiosJwt : axios);

export default {
    apiBase,

    cadastrarCliente(payload, { autenticado = false } = {}) {
        return wrapPublic(cliente(autenticado).post(`${apiBase}/clientes/cadastrar`, payload));
    },

    obterClientePorCpf(cpf, { autenticado = false } = {}) {
        return wrapPublic(cliente(autenticado).get(`${apiBase}/clientes/por-cpf/${cpf}`));
    },

    obterEspacos({ autenticado = false, apenasAtivos = true, apenasComMesas = false } = {}) {
        const url = `${apiBase}/espacos?apenasAtivos=${apenasAtivos}&apenasComMesas=${apenasComMesas}`;
        return wrapPublic(cliente(autenticado).get(url));
    },

    registrarAtendimento(payload, { autenticado = false } = {}) {
        return wrapPublic(cliente(autenticado).post(`${apiBase}/atendimentos/registrar`, payload));
    },

    emitirEtiqueta(payload, { autenticado = false } = {}) {
        return wrapPublic(cliente(autenticado).post(`${apiBase}/atendimentos/etiqueta`, payload, { responseType: 'blob' }));
    },

    obterHorariosAgendados(codigoEspaco, data, { autenticado = false } = {}) {
        const url = `${apiBase}/atendimentos/horarios-agendados/${codigoEspaco}?data=${encodeURIComponent(data)}`;
        return wrapPublic(cliente(autenticado).get(url));
    },

    // Cada mesa retornada inclui `tipo`: "Agendamento" | "Espontanea".
    obterMesasPorEspaco(codigoEspaco, { autenticado = false } = {}) {
        const url = `${apiBase}/mesas/por-espaco/${codigoEspaco}`;
        return wrapPublic(cliente(autenticado).get(url));
    },

    obterHorariosDisponiveisDaMesa(idMesa, data, { autenticado = false } = {}) {
        const params = data ? `?data=${encodeURIComponent(data)}` : '';
        const url = `${apiBase}/mesas/${idMesa}/horarios-disponiveis${params}`;
        return wrapPublic(cliente(autenticado).get(url));
    },

    obterFilaPorAtendente(idAtendente, { incluirChamado = true } = {}) {
        return wrapPublic(axios.get(`${apiBase}/atendimentos/fila-atendente/${idAtendente}?incluirChamado=${incluirChamado}`));
    },

    finalizarAtendimento(idAtendimento, payload) {
        return wrapPublic(axios.put(`${apiBase}/atendimentos/finalizar/${idAtendimento}`, payload));
    },

    chamarProximo(payload) {
        return wrapPublic(axios.post(`${apiBase}/atendimentos/chamar-proximo`, payload));
    },

    registrarAtendente(payload) {
        return wrapPublic(axios.post(`${apiBase}/atendentes/registrar`, payload));
    },

    obterUltimosChamados(quantidade = 3) {
        return wrapPublic(axios.get(`${apiBase}/atendimentos/ultimos-chamados?quantidade=${quantidade}`));
    },

    obterFilaPorEspaco(codigoEspaco, { incluirChamado = true } = {}) {
        return wrapPublic(axios.get(`${apiBase}/atendimentos/fila/${codigoEspaco}?incluirChamado=${incluirChamado}`));
    },

    // Helper exposto caso outros componentes queiram usar axios cru.
    _clientes: { escolherCliente },
}
